import React, { Component } from 'react';
import * as R from 'ramda';
import { loadScripts } from '../../utils.js';
import './drupal.css';

export default class DrupalPage extends Component {

  componentDidMount() {
    // @TODO original prototype tool was developed in jQuery, rewrite to React in future
    const parent = document.getElementsByClassName('drupal-page')[0];

    const entityName = this.props.location.state && this.props.location.state.entity.label;
    const yearName = this.props.location.state && this.props.location.state.year.label;

    const lowerAndReplaceSpace = R.pipe(R.toLower, R.replace(' ', '-'))
    const lowerAndReplaceSlash = R.pipe(R.toLower, R.replace('/', '-'))

    loadScripts(['/jquery/jquery.drupal.js'], parent, () => {
      // jQuery is global via /public/index.html
      // eslint-disable-next-line
      window.$('.drupal-page').mdDrupal({ entity: lowerAndReplaceSpace(entityName), year: lowerAndReplaceSlash(yearName) });
    });
  }

  componentWillUnmount() {
    // @TODO beware of memory leaks?
  }

  render() {
    return (
      <div className='drupal-page' />
    );
  }
}
